import LeadingLinks from '../../components/leading-links';
import AsideNavLink from '../../components/aside-nav-link';
import AsideLayout from '../../components/layouts/aside-layout';
import MainLayout from '../../components/layouts/main-layout';
import HeroImage from '../../public/img/hero/philanthropy_1920_640.jpg';
import PhilanthropicPartners from '../../components/philanthropic-partners';
import Head from 'next/head';

export default function CompanyOverview() {
    return (
        <MainLayout>
            <Head>
                <title>Philanthropy | Solvar</title>
                <meta name="description" content="Solvar philanthropy information."></meta>
            </Head>
            <AsideLayout
                prev={
                    <LeadingLinks href="/about-us/corporate-governance" prev>Corporate Governance</LeadingLinks>
                }
                next={
                    <LeadingLinks href="/about-us/sustainability" next>Sustainability</LeadingLinks>
                }
                heroImage={ HeroImage }
                location={
                    <p className="capitalize text-bb">
                        <span className="font-bold">About Us</span> › Philanthropy
                    </p>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">About Us</h6>
                        <AsideNavLink href="/about-us/company-overview">Company Overview</AsideNavLink>
                        <AsideNavLink href="/about-us/history">History</AsideNavLink>
                        <AsideNavLink href="/about-us/board-of-directors">Board of Directors</AsideNavLink>
                        <AsideNavLink href="/about-us/management-team">Management Team</AsideNavLink>
                        <AsideNavLink href="/about-us/corporate-governance">Corporate Governance</AsideNavLink>
                        <AsideNavLink href="/about-us/philanthropy" active={true}>Philanthropy</AsideNavLink>
                        <AsideNavLink href="/about-us/sustainability">Sustainability</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Investors</h6>
                        <AsideNavLink href="/investors/shareholder-information">Shareholder Information</AsideNavLink>
                        <AsideNavLink href="/investors/company-announcements">Company Announcements</AsideNavLink>
                        <AsideNavLink href="/investors/annual-reports">Annual Reports</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Contact</h6>
                        <AsideNavLink href="/contact/contact-us">Contact Us</AsideNavLink>
                    </>
                }
            >
                <h1 className="text-bb pb-40">Philanthropy</h1>
                <div className="sol-markdown-content">
                    <p>Solvar Limited is focused on improving the health and wellbeing of communities, organisations and charities within Australia and New Zealand. Solvar Limited has a Philanthropic Committee that ensures that our activities maintain alignment with the company's mission, vision and values.</p>
                    <p>Our Philanthropic Committee engages with key partners and regional community organisations. We select partners based on our key focus areas including humanitarian, educational, cultural, social, environmental and community projects.</p>
                    <h6 className="normal-case">Some of our key charity partners include:</h6>
                </div>
                <PhilanthropicPartners />
            </AsideLayout>
        </MainLayout>
    );
}